// extracted by mini-css-extract-plugin
export default {"card_item_rating_text":"RatingCards_card_item_rating_text__yHr6+"};